"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withForwardRef = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _core = require("@emotion/core");
const withForwardRef = Component => {
  const ForwardRef = /*#__PURE__*/_react.default.forwardRef((props, ref) => (0, _core.jsx)(Component, (0, _extends2.default)({}, props, {
    withRef: ref
  })));
  const componentName = Component.displayName || Component.name;
  ForwardRef.displayName = `ForwardRef.${componentName}`;
  return ForwardRef;
};
exports.withForwardRef = withForwardRef;